/* Header vastzetten onder de aankondigingsbalk.
 *
 * De aankondigingsbalk en de header zijn twee losse secties die allebei `position: sticky`
 * met `top: 0` hebben. Twee sticky broers op dezelfde top-waarde gaan over elkaar heen staan;
 * de header verdween daardoor half achter de balk. De header moet dus blijven plakken op de
 * hoogte van die balk, en die hoogte staat niet vast: op desktop is het een regel (~42px),
 * op smalle schermen lopen de twee meldingen door en wordt het drie keer zo hoog.
 *
 * Vandaar hier meten in plaats van een getal in de CSS. De variabele wordt gezet op <html>;
 * de CSS-regel in dynamic.css gebruikt hem met 0 als terugval, zodat de header ook zonder
 * dit script bruikbaar blijft staan (dan alleen weer onder de balk).
 */
(function () {
  function zetHoogte() {
    var balk = document.querySelector('.shopify-section-group-header-group.section-announcement');
    var hoogte = 0;
    // Alleen verrekenen als de balk zelf blijft staan; scrolt hij weg, dan mag de header
    // gewoon tegen de bovenkant.
    if (balk && getComputedStyle(balk).position === 'sticky') {
      hoogte = Math.round(balk.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--dgm-aankondiging-hoogte', hoogte + 'px');
  }

  zetHoogte();
  document.addEventListener('DOMContentLoaded', zetHoogte);
  window.addEventListener('load', zetHoogte);
  window.addEventListener('resize', zetHoogte);

  /* De balk kan van hoogte veranderen zonder dat het venster verandert: een melding die
     wisselt, of een lettertype dat later inlaadt. */
  if (window.ResizeObserver) {
    document.addEventListener('DOMContentLoaded', function () {
      var balk = document.querySelector('.shopify-section-group-header-group.section-announcement');
      if (balk) new ResizeObserver(zetHoogte).observe(balk);
    });
  }
})();
